export const ERROR = {
    ERROR_OCCURRED: 'エラーが発生しました。もう一度お試しください。',
    IS_REQUIRED: 'この項目は入力必須です。',
    NON_NUMERIC_CHARACTERS: '半角数字を入力してください。',
}
